import { inject, injectable } from 'inversify';
import { version_full } from '@Api';
import { IMapper } from '../IMapper';
import { TYPES } from '@Types';
import { VersionGameMapper } from './VersionGameMapper';
import { Version, VersionVersioning } from '@Models';

@injectable()
export class VersionMapper
  implements IMapper<number, version_full, version_full, Version>
{
  @inject(TYPES.Mapper.VersionGameMapper)
  private _versionGameMapper!: VersionGameMapper;

  public map(item: version_full): Version {
    return this.mapFull(item);
  }

  public mapFull(item: version_full): Version {
    return {
      id: item.id,
      name: item.name,
      updatedAt: item.updated_at,
      game: this._versionGameMapper.map(item.game),
      color: item.color ?? '#ff0000',
      isLatest: item.is_latest,
    } satisfies Version as Version;
  }

  public mapVersioning(data: version_full): VersionVersioning {
    return this.mapFull(data);
  }
}
